import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

//Style
import styles from './ValidationsPage.module.scss';

//golbal context
import { GET_ANSWER, GET_QUESTION, SET_ANSWERS_FILTERS, SET_ANSWERS_SCROLL_Y } from '../../actions/types';
import { useGlobalContext } from '../../context/GlobalContext';
import { postAnswersFilteredAction, putAnswerAction } from '../../actions/answerActions';
import { getNotifsAction } from '../../actions/authActions';
import ValidRow from '../../components/partials/ValidRow/ValidRow';
import { IoSearch } from 'react-icons/io5';
import FiltersToggle from '../../components/partials/FiltersToggle';
import FiltersMobilePanel from '../../components/partials/FiltersMobilePanel';
import ValidationFiltersMobile from '../../components/partials/ValidationFiltersMobile';

export default function ValidationsPage() {

  const [context, dispatch] = useGlobalContext();
  const { filteredAnswers, filters, scrollY, count } = context.answers;
  const [search, setSearch] = useState('');
  const [filterIsOpen, setFiltersIsOpen] = useState(false);

  const adminId = context.auth.userAuth?._id;

  const containerRef = useRef(null);
  const scrollRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  function setFilters(key, value) {
    dispatch({
      type: SET_ANSWERS_FILTERS,
      payload: {
        ...filters,
        page: 1,
        [key]: value
      }
    });
  }


  const countFilters = useMemo(() => {
    let count = 0;
    if (filters?.search) {
      count += 1;
    }
    if (filters?.month !== "all") {
      count += 1;
    }
    if (filters?.tags?.length > 0) {
      count += filters?.tags.length;
    }
    return count;
  }, [filters]);

  const initData = useCallback(() => {
    getNotifsAction(dispatch, "Medocta");
    if (scrollY) {
      containerRef.current.scrollTo({
        top: scrollY,
        left: 0,
      });
    }
    dispatch({
      type: GET_QUESTION,
      payload: null
    });
    dispatch({
      type: GET_ANSWER,
      payload: null
    });
  }, [dispatch, scrollY]);

  useEffect(() => {
    initData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    postAnswersFilteredAction(dispatch, filters);
    setIsLoading(true);
    // eslint-disable-next-line
  }, [filters.orderBy, filters]);


  useEffect(() => {
    setIsLoading(false);
  }, [filteredAnswers]);

  function handleScroll(e) {
    dispatch({
      type: SET_ANSWERS_SCROLL_Y,
      payload: e.target.scrollTop
    });
    if (!isLoading && count > filteredAnswers.length && scrollRef?.current.offsetHeight + e.target.scrollTop + 2 > scrollRef?.current.scrollHeight) {
      dispatch({
        type: SET_ANSWERS_FILTERS,
        payload: {
          ...filters,
          page: filters.page + 1,
        }
      });
    }
  }

  function handleChangeAnswer(id, key, value) {
    putAnswerAction(dispatch, id, { [key]: value })
  }

  return (
    <>
      <FiltersToggle
        handleClick={() => setFiltersIsOpen(true)}
        count={countFilters}
      />
      <FiltersMobilePanel
        close={() => setFiltersIsOpen(false)}
        isOpen={filterIsOpen}
      >
        <ValidationFiltersMobile />
      </FiltersMobilePanel>
      <div className={`page-container ${styles.container}`}>
        <div className={styles['header-mobile']}>
          <div className={styles.input}>
            <input type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder='Recherche...'
            />

            <button
              type="button"
              onClick={() => setFilters('search', search)}
              className={search || filters?.search ? styles.valid : ''}
            >
              <IoSearch />
            </button>
          </div>
        </div>
        <div
          ref={containerRef}
          onScroll={(e) => handleScroll(e)}
          className={styles.list}>
          <div className="content" ref={scrollRef}>
            {filteredAnswers?.map((answer) =>
              <ValidRow
                key={answer._id}
                adminId={adminId}
                handleChangeAnswer={handleChangeAnswer}
                answer={answer} />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
